export const state = () => ({
	current_tab: 'account',

	billing_information: null,

	addresses: null,
});
export const mutations = {
	setBillingInformation(state: any, payload: any) {
		state.billing_information = payload;
	},
	setAddresses(state: any, payload: any) {
		state.addresses = payload;
	},
	setCurrentTab(state: any, payload: any) {
		state.current_tab = payload;
	},
};
export const getters = {
	getBillingInformation: (state: any) => state.billing_information,
	getAddresses: (state: any) => state.addresses,
	getCurrentTab: (state: any) => state.current_tab,
};
export const actions = {
	async updateCompanyUser(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/company/' + state.rootState.auth.user.company.uuid + '/users/' + state.rootState.auth.user.uuid, payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updatePassword(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/user/password', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getBillingInformation(state: any, payload: any) {
		if (!state.state.billing_information) {
			return new Promise((resolve, reject) => {
				this.$axios
					.get('/api/company/' + state.rootState.auth.user.company.uuid + '/billing')
					.then((res) => {
						state.commit('setBillingInformation', res.data);
						resolve(res.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
	},

	async getAddresses(state: any, payload: any) {
		if (!state.state.addresses) {
			return new Promise((resolve, reject) => {
				this.$axios
					.get('/api/company/' + state.rootState.auth.user.company.uuid + '/addresses')
					.then((res) => {
						state.commit('setAddresses', res.data);
						resolve(res.data);
					})
					.catch((err) => {
						reject(err);
					});
			});
		}
	},

	async updateCompanyAddress(state: any, payload: any) {
		let addressIndex = null;
		let addressId = state.state.addresses.find((object, index) => {
			addressIndex = index;
			return object.address_type === payload.address_type;
		}).uuid;

		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/company/' + state.rootState.auth.user.company.uuid + '/address/' + addressId, payload)
				.then((res) => {
					let updateState = [...state.state.addresses];
					updateState.splice(addressIndex, 1);
					updateState.push(res.data);

					//Update state with updated address
					state.commit('setAddresses', null);
					state.commit('setAddresses', updateState);

					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateCompanyDetails(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/company/' + state.rootState.auth.user.company.uuid, payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async uploadCompanyLogo(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/company/' + state.rootState.auth.user.company.uuid + '/logo', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateBilling(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/company/' + state.rootState.auth.user.company.uuid + '/billing', payload)
				.then((res) => {
					state.commit('setBillingInformation', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createCompanyAddress(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/company/' + state.rootState.auth.user.company.uuid + '/address', payload)
				.then((res) => {
					state.commit('setAddresses', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateSocials(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/company/' + state.rootState.auth.user.company.uuid + '/socials', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	setCurrentTab(state: any, payload: any) {
		state.commit('setCurrentTab', payload);
	},
};
